import { SET_REPAIR_SERVICES, ADD_REPAIR_NOTES } from './actionTypes';
import { ERROR_REPAIR } from 'store/reducers/errors/actionTypes';
import { getRepairServices as getRepairServicesFromStore } from 'store/reducers/repair/selectors';
import { getIndividualServices } from 'store/reducers/individualServices/actions';
import { SERVICES_KIND } from 'constants/services';

// Selectors
import { getPolicyProperty } from 'store/reducers/dealerSettings/selectors';

const { REPAIR } = SERVICES_KIND;

export const getRepairServices = () => async (dispatch, getState) => {
  if (
    getPolicyProperty(getState())('repairSvcVisible') !== '0' &&
    getRepairServicesFromStore(getState()).length === 0
  ) {
    await dispatch(getIndividualServices(REPAIR, SET_REPAIR_SERVICES));
  }
  if (getPolicyProperty(getState())('repairSvcVisible') === '0') {
    dispatch({
      type: ERROR_REPAIR,
      payload: true
    });
  }
};

export const setRepairServices = repairServices => ({
  type: SET_REPAIR_SERVICES,
  payload: repairServices
});

export const addRepairNotes = (notes, serviceId) => ({
  type: ADD_REPAIR_NOTES,
  payload: { notes, serviceId }
});



// WEBPACK FOOTER //
// ./src/store/reducers/repair/actions.js